// extracted by mini-css-extract-plugin
export var addButton = "_ia-0";
export var border = "_ia-8";
export var check = "_ia-h";
export var danger = "_ia-6";
export var dropdownContainer = "_ia-1";
export var editModalBody = "_ia-j";
export var footerContainer = "_ia-i";
export var fullWidth = "_ia-a";
export var hide = "_ia-9";
export var icon = "_ia-3";
export var input = "_ia-7";
export var inputFlex = "_ia-b";
export var inputWrapper = "_ia-c";
export var manualFocus = "_ia-5";
export var optionButton = "_ia-4";
export var pillWrapper = "_ia-e";
export var pointer = "_ia-2";
export var showOverflow = "_ia-f";
export var tagsFlex = "_ia-d";
export var xButton = "_ia-g";